<div class="icons-container" [ngClass]="[(route === 'class') ? 'matrix' : 'normal']">
    
    <mat-icon class="material-icons-outlined filter-icon pr-20" mat-button [matMenuTriggerFor]="filterMenu" #filter="matMenuTrigger" [ngClass]="{'filter-icon-active' : filter.menuOpen}">
        filter_alt
    </mat-icon>

    <mat-menu class="filter-menu"  #filterMenu="matMenu">
        <mat-radio-group [(ngModel)]="selectedFilter" (ngModelChange)="onFilterChange($event)" aria-label="Select a Filter">
            
            <div>
                <mat-radio-button class="filter-option" value="common" (click)="$event.stopPropagation();">Show All</mat-radio-button>
                <button *ngIf="selectedFilter === 'common'" mat-icon-button (click)="onMoreOptions($event)">
                    <mat-icon *ngIf="!moreOptions" class="filter-add-icon" matTooltip="Show More Options" [matTooltipClass]="'tooltip'" [matTooltipShowDelay]="1000">add</mat-icon>
                    <mat-icon *ngIf="moreOptions" class="filter-remove-icon">remove</mat-icon>
                </button>
                <div [ngClass]="(moreOptions === true && selectedFilter === 'common') ? 'show' : 'hide'">
                    <div class="checkbox-container">
                        <mat-checkbox   class="filter-cb"
                                        (click)="$event.stopPropagation();"
                                        [checked]="allComplete"
                                        [indeterminate]="someComplete()"
                                        (change)="setAll($event.checked)">
                            {{needsAttentionFilter.name}}
                        </mat-checkbox>
                        <div *ngFor="let subtask of needsAttentionFilter.subFilters">
                            <mat-checkbox   class="sub-filter-cb"
                                            (click)="$event.stopPropagation();"
                                            [(ngModel)]="subtask.checked"
                                            (ngModelChange)="updateAllComplete()">
                                {{subtask.name}}
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div flexLayout="row" fxLayoutAlign="space-between">
                    <mat-radio-button class="filter-option" value="needsAttention" (click)="$event.stopPropagation();">Needs Attention</mat-radio-button>
                </div>
            </div>
        </mat-radio-group>
    </mat-menu>
</div>
